module.exports = __webpack_public_path__ + "img/Feature.dd001681.png";